import { contentFolderService } from "fleet/service/content-folder";
import { createApiSaga } from "redux-store/api-sagas";

import {
  CREATE_CONTENT_FOLDER,
  CREATE_CONTENT_FOLDER_ERROR,
  CREATE_CONTENT_FOLDER_SUCCESS,
  LOAD_CONTENT_FOLDERS,
  LOAD_CONTENT_FOLDERS_FAILURE,
  MOVE_TO_CONTENT_FOLDER,
  MOVE_TO_CONTENT_FOLDER_ERROR,
  MOVE_TO_CONTENT_FOLDER_SUCCESS,
} from "./actions";

const reloadContentFoldersSaga = createApiSaga({
  service: contentFolderService.load,
  serviceName: "contentFolderService.load",
  successAction: LOAD_CONTENT_FOLDERS,
  failureAction: LOAD_CONTENT_FOLDERS_FAILURE,
  reload: true,
});

const createContentFolderSaga = createApiSaga({
  service: contentFolderService.new,
  serviceName: "contentFolderService.new",
  fetchAction: CREATE_CONTENT_FOLDER,
  successAction: CREATE_CONTENT_FOLDER_SUCCESS,
  failureAction: CREATE_CONTENT_FOLDER_ERROR,
});

const moveToContentFolderSaga = createApiSaga({
  service: contentFolderService.move,
  serviceName: "contentFolderService.move",
  fetchAction: MOVE_TO_CONTENT_FOLDER,
  successAction: MOVE_TO_CONTENT_FOLDER_SUCCESS,
  failureAction: MOVE_TO_CONTENT_FOLDER_ERROR,
});

const contentFolderSagas = [
  createContentFolderSaga(),
  reloadContentFoldersSaga(),
  moveToContentFolderSaga(),
];

export { contentFolderSagas };
